import React from 'react';
import {observer} from "mobx-react";
import {PREDICTION_WIDGET} from "../../../../prediction-widget/predictions-widget.consts";
import {PredictionViewModel} from "../../../../../domain/full-game/models/prediction/prediction-view-model";
import {AthleteNextGamePredictionItemModule} from "./athlete-next-game.prediction-item.module";
import {PredictionWidgetDetailsPopup} from "../../../../prediction-widget/components/prediction-widget.details-popup";
import {APP} from "../../../../../core/app/consts";
import {AthleteNextGameModuleSuspensionRisk} from "./athlete-next-game.module.suspension-risk";

const Carousel = React.lazy(() => import("../../../../../core/components/carousel/components/carousel"  /* webpackChunkName: "carousel" */ ));

export const AthleteNextGamePredictionsModule = observer(({controller, betsImpressionParams}) => {
  const {state, device, terms, config} = controller;
  const {isSmallView} = device;
  const {WEB_PREDICTIONS_PREV, WEB_PREDICTIONS_NEXT} = terms;
  const {gameId, competitionId, statusGroup, playersBetsPredictions, selectedPrediction, currentLinkModel} = state;

  const onChange = (index) => controller.action(PREDICTION_WIDGET.ACTION_TYPES.marketNavigationClick, {
    index,
    gameId,
    hasOdds: true,
    competitionId,
    status: statusGroup,
    currentLinkModelName: currentLinkModel.name,
    marketType: selectedPrediction.type,
  });

  const carouselProps = {
    onChange,
    isSmallView,
    nextArrowLabel: WEB_PREDICTIONS_NEXT,
    previousArrowLabel: WEB_PREDICTIONS_PREV,
  }

  const predictionProps = {
    controller,
    betsImpressionParams,
    subSource: config.source
  }

  return (
    <>
      <AthleteNextGameModuleSuspensionRisk controller={controller}/>
      <Carousel {...carouselProps}>
        {
          playersBetsPredictions?.map((prediction: PredictionViewModel, index: Number) =>
            <AthleteNextGamePredictionItemModule
              prediction={prediction} key={prediction.id} index={index} {...predictionProps}/>)
        }
      </Carousel>
      <PredictionWidgetDetailsPopup controller={controller} source={APP.ANALYTICS.SOURCES.athleteNextGame}/>
    </>
  )
});
